module.exports = __webpack_public_path__ + "img/grade-icon.7b0d3780.svg";